(function($) {

	$('.js-faq-question').click(function() {
		let item = $(this);
		let target = $(item.data('target'));
		if (target) {
			target.toggleClass('active');
		}
	});

	class GMap {
		constructor(el) {
			this.el = el;
			this.data = window[el.data('markers')];

			this.init();
		}

		loadGapi() {
			let gapiPromise = new Promise((resolve) => {
				window['scolar_onGapiLoaded'] = () => resolve();
				const gapiNode = document.createElement('script');

				gapiNode.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAhA2um3KmZdeJ5DA5FXh5Cra5NN4QalCY&callback=scolar_onGapiLoaded';
				gapiNode.type = 'text/javascript';

				document.getElementsByTagName('head')[0].appendChild(gapiNode);
			});

			return gapiPromise;
		}

		drawMarkers() {
			let self = this;
			this.data.forEach(markerData => {
				const icon = {
					url: '/wp-content/themes/fundacjascolar/img/ico-marker.svg',
					size: new google.maps.Size(26, 34),
				};
				let position = new google.maps.LatLng(markerData.lat, markerData.lng);
				let marker = new google.maps.Marker({
					position: position,
					map: this.map,
					icon: icon,
				});
				this.mapBounds.extend(position);

				if (markerData.clickable) {
					marker.addListener('click', function() {
						self.infowindow.setContent(markerData.content);
						self.infowindow.open(self.map, marker);
					});

				}
			});

			if (this.data.length > 1) {
				this.map.fitBounds(this.mapBounds);
			}
		}

		initMap() {
			let mapProp = {
				center: new google.maps.LatLng(this.data[0].lat, this.data[0].lng),
				zoom: 15,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: true,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,

				styles: [
					{
						'featureType': 'all',
						'elementType': 'all',
						'stylers': [{'visibility': 'off'}],
					}, {
						'featureType': 'administrative',
						'elementType': 'geometry',
						'stylers': [{'weight': '0.5'}, {'visibility': 'on'}],
					}, {
						'featureType': 'administrative',
						'elementType': 'labels',
						'stylers': [{'visibility': 'simplified'}],
					}, {
						'featureType': 'administrative',
						'elementType': 'labels.text',
						'stylers': [{'lightness': '-50'}, {'saturation': '-50'}],
					}, {
						'featureType': 'administrative.neighborhood',
						'elementType': 'labels.text',
						'stylers': [
							{'hue': '#009aff'},
							{'saturation': '25'},
							{'lightness': '0'},
							{'visibility': 'simplified'},
							{'gamma': '1'}],
					}, {
						'featureType': 'landscape',
						'elementType': 'geometry',
						'stylers': [{'saturation': '0'}, {'lightness': '100'}, {'gamma': '2.31'}, {'visibility': 'on'}],
					}, {
						'featureType': 'landscape',
						'elementType': 'labels',
						'stylers': [{'visibility': 'simplified'}, {'lightness': '20'}, {'gamma': '1'}],
					}, {
						'featureType': 'landscape',
						'elementType': 'labels.text.fill',
						'stylers': [{'saturation': '-100'}, {'lightness': '-100'}],
					}, {
						'featureType': 'landscape',
						'elementType': 'labels.text.stroke',
						'stylers': [{'visibility': 'off'}],
					}, {
						'featureType': 'landscape.man_made',
						'elementType': 'all',
						'stylers': [{'visibility': 'simplified'}],
					}, {
						'featureType': 'poi',
						'elementType': 'all',
						'stylers': [{'visibility': 'off'}],
					}, {
						'featureType': 'poi.park',
						'elementType': 'geometry',
						'stylers': [
							{'lightness': '0'},
							{'saturation': '45'},
							{'gamma': '4.24'},
							{'visibility': 'simplified'},
							{'hue': '#00ff90'}],
					}, {
						'featureType': 'poi.park',
						'elementType': 'labels',
						'stylers': [{'visibility': 'off'}],
					}, {
						'featureType': 'road',
						'elementType': 'all',
						'stylers': [{'visibility': 'on'}],
					}, {
						'featureType': 'road',
						'elementType': 'geometry',
						'stylers': [{'saturation': '-100'}, {'color': '#f5f5f5'}],
					}, {
						'featureType': 'road',
						'elementType': 'labels.text',
						'stylers': [{'visibility': 'simplified'}, {'color': '#666666'}],
					}, {
						'featureType': 'road',
						'elementType': 'labels.icon',
						'stylers': [{'visibility': 'off'}],
					}, {
						'featureType': 'road.highway',
						'elementType': 'geometry.stroke',
						'stylers': [{'visibility': 'off'}],
					}, {
						'featureType': 'road.arterial',
						'elementType': 'geometry.stroke',
						'stylers': [{'visibility': 'off'}],
					}, {
						'featureType': 'transit',
						'elementType': 'labels.icon',
						'stylers': [{'saturation': '-25'}],
					}, {
						'featureType': 'transit.line',
						'elementType': 'all',
						'stylers': [{'visibility': 'simplified'}],
					}, {
						'featureType': 'transit.station.airport',
						'elementType': 'labels.icon',
						'stylers': [{'visibility': 'off'}],
					}, {
						'featureType': 'water',
						'elementType': 'all',
						'stylers': [{'visibility': 'on'}],
					}, {
						'featureType': 'water',
						'elementType': 'geometry.fill',
						'stylers': [{'lightness': '50'}, {'gamma': '.75'}, {'saturation': '100'}],
					}, {
						'featureType': 'water',
						'elementType': 'labels',
						'stylers': [{'visibility': 'simplified'}],
					}, {'featureType': 'water', 'elementType': 'labels.icon', 'stylers': [{'visibility': 'off'}]}],
			};

			this.map = new google.maps.Map(this.el.get(0), mapProp);
			this.mapBounds = new google.maps.LatLngBounds();
			this.infowindow = new google.maps.InfoWindow();

			this.drawMarkers();
		}

		init() {
			if (typeof window['google'] == 'object' && google.maps) {
				this.initMap();
			} else {
				this.loadGapi().then(() => this.initMap());
			}
		}
	}

	class OwlWithPSWP {
		constructor(container) {
			let self = this;
			this.container = container;
			this.thumbs = container.find('.owl-carousel');
			this.pspwSlides = window[container.data('pswp')];
			this.pswpElement = $('.pswp').get(0);
			this.carousel = null;
			this.currentIndex = 0;

			this.init();
		}

		init() {
			let self = this;

			setTimeout(function() {
				self.carousel = self.thumbs.owlCarousel({
					items: 4,
					dots: false,
					nav: false,
					loop: true,
					autoWidth: true,
					autoplay: true,
					autoplaySpeed: 800,
					autoplayTimeout: 2000,
				});
			}, 100);

			this.thumbs.on('initialized.owl.carousel', function() {
				self.thumbs.find('.owl-item').eq(0).addClass('current');
			});

			this.thumbs.on('click', '.owl-item', function(e) {
				let me = $(this);
				let options = {
					index: $(this).find('> div').data('index'),
					showHideOpacity: true,
					history: false,
					getThumbBoundsFn: function(index) {
						var thumbnail = me.get(0), // find thumbnail
							pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
							rect = thumbnail.getBoundingClientRect();

						return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
					},
				};
				let gallery = new PhotoSwipe(self.pswpElement, PhotoSwipeUI_Default, self.pspwSlides, options);
				gallery.init();
			});
		}
	};

	class ImagesGallery {
		constructor(el) {
			this.el = el;
			this.ajaxcontainer = el.find('.ajaxcontainer');
			this.pagination = el.find('.pagination');
			this.pspwSlides = window.gallerydata;
			this.pswpElement = $('.pswp').get(0);
			this.perpage = el.data('perpage');
			this.template = _.template($('#galleryItem').html());

			this.state = {
				page: 1,
			};

			this.init();
		}

		initPswp() {
			let self = this;
			this.ajaxcontainer.on('click', '.enlargable', function(e) {
				let me = $(this);
				let options = {
					index: $(this).data('index'),
					showHideOpacity: true,
					history: false,
					getThumbBoundsFn: function(index) {
						var thumbnail = me.get(0), // find thumbnail
							pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
							rect = thumbnail.getBoundingClientRect();

						return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
					},
				};
				let gallery = new PhotoSwipe(self.pswpElement, PhotoSwipeUI_Default, self.pspwSlides, options);
				gallery.init();
			});
		}

		initPagination() {
			let self = this;
			this.pagination.on('click', 'a', function(e) {
				e.preventDefault();
				let me = $(this);

				self.pagination.find('.current').removeClass('current');
				me.addClass('current');

				self.renderPage($(this).text());
			});
		}

		renderPage(num) {
			let self = this;
			this.state.page = num;
			self.ajaxcontainer.addClass('loading');

			let startIndex = (num - 1) * this.perpage;
			let items = this.pspwSlides.slice(startIndex, startIndex + this.perpage);

			let output = '';
			items.forEach(item => {
				output += this.template(item);
			});

			$('body, html').stop().animate({
				scrollTop: self.ajaxcontainer.offset().top - 80,
			}, function() {
				self.ajaxcontainer.html(output).removeClass('loading');
				self.el.css({
					'min-height': self.ajaxcontainer.height() - self.pagination.height(),
				});
			});
		}

		init() {
			let self = this;
			this.initPswp();
			this.initPagination();

			setTimeout(function() {

			}, 1000);
		}
	}

	class PSWPVideo {
		constructor(el) {
			this.el = el;
			this.pswpElement = $('.pswp').get(0);
			this.template = _.template($('#videoItem').html());
			this.url = el.data('url');

			this.init();
		}

		initPswp() {
			let self = this;

			this.pspwSlides = [
				{
					html: self.template({url: self.url}),
					title: self.el.data('title'),
				}];

			this.el.on('click', function(e) {
				let me = $(this);
				let options = {
					showHideOpacity: true,
					history: false,
					getThumbBoundsFn: function(index) {
						var thumbnail = me.get(0), // find thumbnail
							pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
							rect = thumbnail.getBoundingClientRect();

						return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
					},
				};
				let gallery = new PhotoSwipe(self.pswpElement, PhotoSwipeUI_Default, self.pspwSlides, options);
				gallery.init();
				gallery.listen('destroy', function() {
					console.log('destroy');
					$('.pswp__zoom-wrap').empty();
				});
			});
		}

		init() {
			let self = this;
			this.initPswp();
		}
	}

	window.App = {
		ui: {
			w: $(window),
			b: $('body'),
			h: $('.pageHeader'),
			f: $('.pageFooter'),
			canvas: $('.canvas'),
			screens: $('.screen'),
			nav: $('.pageNav'),
			navwrap: $('.pageNav__wrap'),
			gotop: $('.scrollTop'),
		},

		mobileCheck: function() {
			var isMobile = {
				Android: function() {
					return navigator.userAgent.match(/Android/i);
				},
				BlackBerry: function() {
					return navigator.userAgent.match(/BlackBerry/i);
				},
				iOS: function() {
					return navigator.userAgent.match(/iPhone|iPad|iPod/i);
				},
				Opera: function() {
					return navigator.userAgent.match(/Opera Mini/i);
				},
				Windows: function() {
					return navigator.userAgent.match(/IEMobile/i);
				},
				any: function() {
					return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() ||
						isMobile.Windows());
				},
			};

			return isMobile.any();
		},

		state: {
			headerHeight: null,
			popup: null,
		},

		header: function() {
			let self = this;

			let debounced = _.debounce(function() {
				self.state.headerHeight = self.ui.h.outerHeight();
			}, 100);

			debounced();
			$(window).on('resize orientationchange', debounced);

			let throttled = _.throttle(function() {
				let st = self.ui.w.scrollTop();
				let offset = self.state.headerHeight + 62;

				if (self.ui.b.hasClass('is-navexpanded')) return;

				if (st > offset && !self.ui.b.hasClass('fixed-header')) {
					self.ui.b.addClass('fixed-header');
					self.ui.navwrap.addClass('fadeInDown');
					self.ui.gotop.addClass('is-visible');
				}
				if (st <= offset && self.ui.b.hasClass('fixed-header')) {
					self.ui.b.removeClass('fixed-header');
					self.ui.navwrap.removeClass('fadeInDown');
					self.ui.gotop.removeClass('is-visible');
				}
			}, 150);

			throttled();
			self.ui.w.on('scroll', throttled);

			self.ui.gotop.on('click', function(e) {
				e.preventDefault();
				$('body, html').stop().animate({
					scrollTop: 0,
				});
			});
		},

		toggleBurger: function() {
			let burger = $('.pageNav .js-toggle-nav');

			burger.on('click', () => {
				if (this.ui.b.hasClass('is-navexpanded')) {
					this.ui.b.removeClass('is-navexpanded');
					this.resetNavSubmenus();
				} else {
					this.ui.b.addClass('is-navexpanded');
				}
			});
		},

		isMobileNavViewport: function() {
			return window.matchMedia('(max-width: 991px)').matches;
		},

		resetNavSubmenus: function() {
			const menuItems = this.ui.nav.find('.has-open-submenu');
			menuItems.removeClass('has-open-submenu');
			menuItems.children('.pageNav__linkRow').find('.js-nav-submenu-toggle').attr('aria-expanded', 'false');

			if (this.isMobileNavViewport()) {
				this.ui.nav.find('.sub-menu').stop(true, true).slideUp(0);
			} else {
				this.ui.nav.find('.sub-menu').removeAttr('style');
			}
		},

		navSubmenus: function() {
			const self = this;
			const nav = self.ui.nav;

			nav.on('click', '.js-nav-submenu-toggle', function(e) {
				const button = $(this);
				const item = button.closest('li');
				const submenu = item.children('.sub-menu');

				if (!submenu.length) return;

				e.preventDefault();

				if (!self.isMobileNavViewport()) {
					return;
				}

				const isOpen = item.hasClass('has-open-submenu');
				const siblingItems = item.siblings('.has-open-submenu');

				siblingItems.removeClass('has-open-submenu')
					.find('> .pageNav__linkRow .js-nav-submenu-toggle')
					.attr('aria-expanded', 'false');
				siblingItems.find('.sub-menu').stop(true, true).slideUp(200);

				if (isOpen) {
					item.removeClass('has-open-submenu');
					button.attr('aria-expanded', 'false');
					submenu.stop(true, true).slideUp(200);
					item.find('.has-open-submenu')
						.removeClass('has-open-submenu')
						.children('.pageNav__linkRow')
						.find('.js-nav-submenu-toggle')
						.attr('aria-expanded', 'false');
					item.find('.sub-menu').stop(true, true).slideUp(200);
					return;
				}

				item.addClass('has-open-submenu');
				button.attr('aria-expanded', 'true');
				submenu.stop(true, true).slideDown(200);
			});

			$(window).on('resize orientationchange', _.debounce(function() {
				if (!self.isMobileNavViewport()) {
					self.resetNavSubmenus();
				} else if (!self.ui.b.hasClass('is-navexpanded')) {
					self.resetNavSubmenus();
				}
			}, 100));
		},

		carousel: function() {
			let carousels = $('.infoSlider .owl-carousel');
			carousels.each(function() {
				let cConf = {
					nav: true,
					// navText: [],
					dots: true,
					// navClass: ['carousel-control-prev b-slider-blue-left','carousel-control-next b-slider-blue-right'],
					items: 1,
					responsive: {
						320: {
							autoHeight: true,
						},
						768: {
							autoWidth: true,
							autoHeight: false,
						},
					},
				};
				let c = $(this).owlCarousel(cConf);
			});

		},

		cookies: function() {
			let accepted = Cookies.get('scolarcookies');
			if (accepted) return;

			let cookieDiv = $('#cookie-notice'),
				cookieBtn = $('#set-cookie-button');

			cookieDiv.fadeIn(250);
			cookieBtn.on('click', function(e) {
				e.preventDefault();

				Cookies.set('scolarcookies', '1', {expires: 30});
				cookieDiv.fadeOut(250);
			});
		},

		scrollDown: function() {
			let self = this;

			$('.ui-scrolldown').on('click', function(e) {
				e.preventDefault();
				let me = $(this);

				let tgt = me.parents('.pageSection').next('.pageSection');
				if (tgt.length) {
					$('body, html').stop().animate({
						scrollTop: tgt.offset().top - 70,
					});
				}
			});
		},

		popups: function() {
			$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
				type: 'iframe',
				mainClass: 'mfp-fade contentPopup',
				removalDelay: 160,
				preloader: false,
				showCloseBtn: false,
				fixedContentPos: false,
				iframe: {
					markup: '<div class="mfp-content-popup"><div class="iframePopup"><div class="mfp-iframe-scaler"> <iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe></div> <button class="mfp-close" title="Zamknij (esc)"> <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 47.971 47.971" style="enable-background:new 0 0 47.971 47.971;" xml:space="preserve"> <path d="M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88 c-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242 C1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879 s1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"/> </svg> </button></div></div>',
					patterns: {
						youtube: {
							index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

							id: 'v=', // String that splits URL in a two parts, second part should be %id%
							// Or null - full URL will be returned
							// Or a function that should return %id%, for example:
							// id: function(url) { return 'parsed id'; }

							src: '//www.youtube.com/embed/%id%?autoplay=1', // URL that will be set as a source for iframe.
						},
						vimeo: {
							index: 'vimeo.com/',
							id: '/',
							src: '//player.vimeo.com/video/%id%?autoplay=1',
						},
						gmaps: {
							index: '//maps.google.',
							src: '%id%&output=embed',
						},
					},
				},
			});

			$('.js-inline-popup').magnificPopup({
				disableOn: 700,
				type: 'inline',
				mainClass: 'mfp-fade contentPopup',
				removalDelay: 160,
				preloader: false,
				showCloseBtn: false,
				fixedContentPos: false,
			});
		},

		picsCarousels: function() {
			let containers = $('.picsCarousel');
			containers.each(function() {
				new OwlWithPSWP($(this));
			});
		},

		sliders: function() {
			let sliders = $('.js-slider');
			sliders.each(function() {
				$(this).owlCarousel({
					loop: true,
					margin: 0,
					nav: true,
					responsive: {
						0: {
							items: 1,
						},
						600: {
							items: 1,
						},
						1000: {
							items: 1,
						},
					},
				});
			});
		},

		partnersCarousel: function() {
			let self = this;
			let container = $('.partnersCarousel');
			self.state.partnersCarousel = container.owlCarousel({
				nav: true,
				dots: false,
				autoplay: true,
				autoplayTimeout: 2000,
				autoplaySpeed: 800,
				margin: 44,
				loop: true,
				responsive: {
					320: {
						items: 1,
					},
					600: {
						items: 2,
					},
					768: {
						items: 3,
					},
					1024: {
						items: 4,
					},
					1200: {
						items: 5,
					},
				},
			});

			container.on('initialized.owl.carousel changed.owl.carousel', function() {
				container.find('.owl-item:not(.active) [tabindex]').attr('tabindex', '-1');
				container.find('.owl-item.active [tabindex]').attr('tabindex', '0');
			});

			$('body').on('keydown', '.partnerWrapper', function(e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});

			container.on('click', '.button', function() {
				self.state.partnersCarousel.trigger('stop.owl.autoplay');
			});

			let toggleButton = `<button class="partnersCarousel-toggle" aria-label="Zatrzymaj" type="button">
									    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512" viewBox="0 0 300 300">
									      <path d="m126.6 158.4-86.4 56.1c-6.7 4.3-15-1.1-15-9.7V95.3c0-8.7 8.3-14.1 15-9.7l86.4 56.1c6.1 3.9 6.1 12.7 0 16.7zM198.7 216h-25.4c-5.5 0-10-4.5-10-10V94.6c0-5.5 4.5-10 10-10h25.4c5.5 0 10 4.5 10 10V206c0 5.5-4.4 10-10 10zM264.8 216h-25.4c-5.5 0-10-4.5-10-10V94.6c0-5.5 4.5-10 10-10h25.4c5.5 0 10 4.5 10 10V206c0 5.5-4.5 10-10 10z" fill="#000000"/>
									    </svg>
									  </button>`;

			container.find('.owl-nav').append(toggleButton);

			$('.partnersCarousel-toggle').on('click', function() {
				let carousel = self.state.partnersCarousel;
				let autoplayInfo = carousel.data('owl.carousel').settings.autoplay;
				let toggleButton = $(this);

				if (autoplayInfo) {
					carousel.trigger('stop.owl.autoplay');
					carousel.data('owl.carousel').settings.autoplay = false;
					toggleButton.attr('aria-label', 'Wznów karuzelę');
				} else {
					carousel.trigger('play.owl.autoplay');
					carousel.data('owl.carousel').settings.autoplay = true;
					toggleButton.attr('aria-label', 'Zatrzymaj karuzelę');
				}
			});
		},

		maps: function() {
			let maps = $('.map');
			if (!maps.length) return;

			maps.each(function() {
				new GMap($(this));
			});
		},

		_firePopup: function(tpl, obj, id) {
			let self = this;

			let template = _.template($('#' + tpl).html());
			let popHtml = template(window[obj][id]);

			self.state.popup = $.magnificPopup.open({
				disableOn: 700,
				items: {
					src: popHtml,
					type: 'inline',
				},
				mainClass: 'mfp-fade contentPopup',
				removalDelay: 160,
				preloader: false,
				fixedContentPos: false,
				showCloseBtn: false,
				callbacks: {
					close: function() {
						if (self.state.partnersCarousel) {
							self.state.partnersCarousel.trigger('play.owl.autoplay');
						}
					},
				},
			});

			console.log(tpl, obj, id);
		},

		contentPopup: function() {
			let self = this;
			$('body').on('click', '.js-contentPop', function(e) {
				e.preventDefault();
				let me = $(this);
				self._firePopup(me.data('template'), me.data('obj'), me.data('id'));
			});
		},

		readmore: function() {
			$('.js-readmore').on('click', function(e) {
				e.preventDefault();

				let me = $(this);
				let container = me.parent();
				let content = me.next('.readmore__content');

				if (container.hasClass('expanded')) {
					container.removeClass('expanded');
					content.stop().slideUp();
				} else {
					container.addClass('expanded');
					content.stop().slideDown();
				}
			});
		},

		hashchange: function() {
			$('.article a').on('click', function(e) {
				let hsh = $(this).attr('href').split('#')[1];
				if (!hsh) return;

				let tgt = $('#' + hsh);
				if (tgt) {
					e.preventDefault();
					$('body, html').stop().animate({
						scrollTop: tgt.offset().top - parseInt(tgt.css('marginTop'), 10) - 50,
					});
				}
			});
		},

		galleries: function() {
			if (!window.isJsGallery) return;

			new ImagesGallery($('.js-gallery'));

			$('.js-gallery-mov').each(function() {
				new PSWPVideo($(this));
			});
		},

		globalForm: function() {
			if (!window.scolar_is_global_form) return;

			let frm = $('.globalForm form');
			let typeSelect = frm.find('.wpcf7-opcje_scolar');
			let typeInput = frm.find('[name="formtype"]');
			let temat = frm.find('[name="temat"]');

			function setitup() {
				let selectedOption = typeSelect.find(':selected');
				let selected = selectedOption.data('formtype');
				let selectedTemat = selectedOption.text();
				typeInput.val(selected);
				temat.val(selectedTemat);

				if (selected == 'simple') {
					frm.find('.formtype-full').css({
						opacity: 0.35,
					});
					frm.find('.formtype-full input').prop('disabled', true);
				} else {
					frm.find('.formtype-full').css({
						opacity: 1,
					});
					frm.find('.formtype-full input').prop('disabled', false);
				}
			}

			setitup();
			typeSelect.on('change', function(e) {
				setitup();
			});

			jQuery.datetimepicker.setLocale('pl');
			$('.pickdate').datetimepicker({
				lang: 'pl',
				format: 'd.m.Y',
				timepicker: false,
			});
		},

		ninjaFormsWCAG: function() {
			if (typeof nfRadio === 'undefined') return;

			const self = this;

			function fixFieldAccessibility($container) {
				const $input = $container.find('input:not([type="checkbox"]):not([type="radio"]), textarea, select')
					.first();
				const $label = $container.find('.nf-field-label label').first();
				const labelText = $label.text().trim();

				if (!$input.length) return;

				let fieldId = $input.attr('id');
				if (!fieldId) {
					fieldId = 'nf-field-' + Math.random().toString(36).substr(2, 9);
					$input.attr('id', fieldId);
				}

				if (labelText) {
					if (!$label.attr('for')) {
						$label.attr('for', fieldId);
					}
					if (!$label.attr('id')) {
						$label.attr('id', 'nf-label-' + fieldId);
					}

					$input.attr('aria-labelledby', $label.attr('id'));
				}

				if ($container.hasClass('required-field') || $container.find('.ninja-forms-req-symbol').length) {
					$input.attr('aria-required', 'true').attr('required', 'required');
				}

				$input.removeAttr('aria-label aria-describedby');
			}

			function fixCheckboxRadio($element) {
				const $input = $element.find('input[type="checkbox"], input[type="radio"]');

				$input.each(function() {
					const $checkbox = $(this);
					const inputId = $checkbox.attr('id');
					const $containerLabel = $checkbox.closest('.nf-field-container')
						.find('.nf-field-label label')
						.first();

					$checkbox.parents('a').each(function() {
						const $link = $(this);
						if (!$link.closest('.nf-field-label').length) {
							$link.replaceWith($link.contents());
						}
					});

					const $fieldElement = $checkbox.closest('.nf-field-element');
					if ($fieldElement.parent('a').length &&
						!$fieldElement.parent('a').closest('.nf-field-label').length) {
						$fieldElement.unwrap();
					}

					if (!inputId) {
						const newId = 'nf-field-' + Math.random().toString(36).substr(2, 9);
						$checkbox.attr('id', newId);
					}

					if ($containerLabel.length) {
						if (!$containerLabel.attr('id')) {
							$containerLabel.attr('id', 'nf-label-' + (inputId || $checkbox.attr('id')));
						}
						$checkbox.attr('aria-labelledby', $containerLabel.attr('id'));
						$containerLabel.attr('for', $checkbox.attr('id'));
					}

					$checkbox.removeAttr('aria-label aria-describedby');
					$checkbox.attr('tabindex', '0');

					$checkbox.off('keydown.nfwcag').on('keydown.nfwcag', function(e) {
						if (e.key === ' ' || e.key === 'Enter') {
							e.preventDefault();
							this.checked = !this.checked;
							$(this).trigger('change');
						}
					});

					$containerLabel.attr('tabindex', '-1');
					$containerLabel.off('click.nfwcag keydown.nfwcag')
						.on('click.nfwcag', function(e) {
							if (!$(e.target).is('a')) {
								e.preventDefault();
								$checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
							}
						})
						.on('keydown.nfwcag', function(e) {
							if ((e.key === ' ' || e.key === 'Enter') && !$(e.target).is('a')) {
								e.preventDefault();
								$checkbox.trigger('focus').trigger('click');
							}
						});

					$checkbox.off('focus.nfwcag blur.nfwcag')
						.on('focus.nfwcag', function() {
							$(this).closest('.nf-field-container').addClass('nf-focused');
						})
						.on('blur.nfwcag', function() {
							$(this).closest('.nf-field-container').removeClass('nf-focused');
						});
				});
			}

			function fixErrorMessages(fieldId, errors) {
				const $field = $('#nf-field-' + fieldId);
				const $container = $field.closest('.nf-field-container');
				const fieldErrorId = 'nf-error-' + fieldId;

				if (errors && Array.isArray(errors) && errors.length > 0) {
					const errorMsg = (errors[0] && errors[0].message) ? errors[0].message : 'To pole jest wymagane';

					$field.attr('aria-invalid', 'true');
					$field.attr('aria-describedby', fieldErrorId);

					let $errorContainer = $('#' + fieldErrorId);
					if (!$errorContainer.length) {
						$errorContainer = $('<div role="alert" aria-live="polite"></div>').attr('id', fieldErrorId);
						$container.find('.nf-after-field').prepend($errorContainer);
					}

					$errorContainer.addClass('nf-error-msg').html(errorMsg);

					setTimeout(function() {
						const $announce = $('<div role="status" aria-live="assertive" class="sr-only"></div>')
							.text('Błąd: ' + errorMsg)
							.appendTo('body');

						setTimeout(function() { $announce.remove(); }, 2000);
					}, 100);
				} else {
					$field.removeAttr('aria-invalid aria-describedby');
					$('#' + fieldErrorId).remove();
				}
			}

			$('.nf-form-cont').each(function() {
				$(this).removeAttr('aria-labelledby aria-describedby aria-live role');
			});

			$('#nf-form-errors-76').removeAttr('role');

			if (!$('#nf-accessibility-styles').length) {
				$('<style id="nf-accessibility-styles">').text(`
      .nf-focused {
        outline: 2px solid #0066cc !important;
        outline-offset: 2px !important;
      }
      .nf-field-element input:focus,
      .nf-field-element textarea:focus,
      .nf-field-element select:focus {
        outline: 2px solid #0066cc !important;
        outline-offset: 2px !important;
      }
      .nf-field-element input[type="checkbox"]:focus,
      .nf-field-element input[type="radio"]:focus {
        outline: 2px solid #0066cc !important;
        outline-offset: 2px !important;
        opacity: 1 !important;
        position: relative !important;
        width: auto !important;
        height: auto !important;
      }
      .nf-error-msg {
        color: #d63638;
        font-size: 14px;
        margin-top: 5px;
      }
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0,0,0,0);
        white-space: nowrap;
        border-width: 0;
      }
    `).appendTo('head');
			}

			nfRadio.channel('form').on('render:view', function(view) {
				setTimeout(function() {
					$('.nf-form-cont').removeAttr('aria-labelledby aria-describedby aria-live role');
					$('#nf-form-errors-76').removeAttr('role');

					$('.nf-field-container').each(function() {
						fixFieldAccessibility($(this));
					});

					$('.nf-field-element').each(function() {
						fixCheckboxRadio($(this));
					});
				}, 200);
			});

			nfRadio.channel('fields').on('add:field', function(model) {
				setTimeout(function() {
					const fieldId = model.get('id');
					const $container = $('#nf-field-' + fieldId + '-container');

					fixFieldAccessibility($container);
					fixCheckboxRadio($container.find('.nf-field-element'));
				}, 100);
			});

			nfRadio.channel('fields').on('change:modelValue', function(model) {
				setTimeout(function() {
					const fieldId = model.get('id');
					const errors = model.get('errors');
					fixErrorMessages(fieldId, errors);
				}, 100);
			});

			nfRadio.channel('form').on('submit:response', function(response) {
				if (response.errors && response.errors.fields) {
					Object.keys(response.errors.fields).forEach(function(fieldId) {
						const errors = response.errors.fields[fieldId];
						fixErrorMessages(fieldId, errors);
					});
				}
			});
		},

		debug: function() {
			let d = $('#debug');
			if (!d.length) return;

			d.html(window.innerWidth);
			$(window).on('resize', function() {
				d.html(window.innerWidth);
			});
		},

		init: function() {
			const ismobile = this.mobileCheck();

			window.ismobile = ismobile;
			if (ismobile) {
				this.ui.b.addClass('is-mobile');
			} else {
				this.ui.b.addClass('is-desktop');
			}

			if (navigator.userAgent.match(/Webkit/i)) {
				this.ui.b.addClass('is-webkit');
			}

			this.header();
			// this.footer();
			this.toggleBurger();
			this.navSubmenus();
			this.scrollDown();
			this.carousel();
			this.popups();
			this.picsCarousels();
			this.sliders();
			this.maps();
			this.contentPopup();
			this.partnersCarousel();
			this.readmore();
			this.hashchange();
			this.galleries();
			this.globalForm();
			this.cookies();
			this.debug();
			this.ninjaFormsWCAG();
		},
	};

	$(document).ready(() => {
		App.init();
	});

})(jQuery);
